import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  activityReport: null,
  elearningCourses: null,
  elearningCoursesContents: null,
  elearningGrades: null,
  elearningUser: null,
  elearningSettings: null,
  bookTime: null,
  bookMapaData: null,
  bookModuleSettings: null,
  quizAttempts: null,
  isLimitExceeded: false,
  timeLimitPerDay: null,
  totalTodayTime: null,
  quizzes: {},
}

export const elearningSlice = createSlice({
  name: 'elearning',
  initialState,
  reducers: {
    updateElearningData: (state, action) => {
      state = { ...state, ...action.payload }
      return state
    },
  }
})

export const { updateElearningData } = elearningSlice.actions
export const selectElearningCourses = state => state.elearning.elearningCourses
export const selectElearningCoursesContents = state => state.elearning.elearningCoursesContents
export const selectElearningGrades = state => state.elearning.elearningGrades
export const selectElearningUser = state => state.elearning.elearningUser
export const selectElearningSettings = state => state.elearning.elearningSettings
export const selectActivityReport = state => state.elearning.activityReport
export const selectBookTime = state => state.elearning.bookTime
export const selectBookMapaData = state => state.elearning.bookMapaData
export const selectQuizAttempts = state => state.elearning.quizAttempts
export const selectIsLimitExceeded = state => state.elearning.isLimitExceeded
export const selectElearningData = state => state.elearning
export const selectTimeLimitPerDay = state => state.elearning.timeLimitPerDay
export const selectTotalTodayTime = state => state.elearning.totalTodayTime
// Defensive: prior versions persisted `quizzes` as an array. After upgrade
// the shape becomes a map keyed by courseId. Guard against the legacy
// array sneaking in from redux-persist on first load post-deploy.
export const selectQuizzes = state => {
  const q = state.elearning?.quizzes
  if (!q || Array.isArray(q)) return {}
  return q
}
export default elearningSlice.reducer
